
import Component from "./index.vue"
export default {
    id: "learning-objective-to-objective", // (required) uuid
    icon: require("./icon.svg"), // (required) url to tool icon
    title: "Convert old objective format", // (required) Title shown on content tools view
    description: "Convert content using the old Learning Objective format to the newest Objective format", // (required) Operation description
    available: true, // (optional) set to true if tool is available to use in the platform
    Component // (required) VueComponent to show when operation is selected
}